var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeEconomics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8334 31.8333H2.16675M2.16675 14.4167L15.0329 4.125C15.8751 3.45128 16.9216 3.08423 18.0001 3.08423C19.0786 3.08423 20.125 3.45128 20.9672 4.125L33.8334 14.4167M23.5417 5.70833V2.54167C23.5417 2.3317 23.6252 2.13034 23.7736 1.98187C23.9221 1.83341 24.1235 1.75 24.3334 1.75H28.2917C28.5017 1.75 28.7031 1.83341 28.8515 1.98187C29 2.13034 29.0834 2.3317 29.0834 2.54167V10.4583M5.33341 31.8333V12.0417M30.6667 31.8333V12.0417",
    stroke: "#25A249",
    strokeWidth: 2.375,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 31.8333V23.9167C22.75 21.6778 22.75 20.5584 22.0533 19.8633C21.3598 19.1667 20.2404 19.1667 18 19.1667C15.7596 19.1667 14.6417 19.1667 13.9467 19.8633C13.25 20.5568 13.25 21.6763 13.25 23.9167V31.8333M21.1667 12.0417C21.1667 12.8815 20.833 13.687 20.2392 14.2808C19.6453 14.8747 18.8399 15.2083 18 15.2083C17.1601 15.2083 16.3547 14.8747 15.7608 14.2808C15.167 13.687 14.8333 12.8815 14.8333 12.0417C14.8333 11.2018 15.167 10.3964 15.7608 9.8025C16.3547 9.20863 17.1601 8.875 18 8.875C18.8399 8.875 19.6453 9.20863 20.2392 9.8025C20.833 10.3964 21.1667 11.2018 21.1667 12.0417Z",
    stroke: "#25A249",
    strokeWidth: 2.375
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeEconomics);
export default __webpack_public_path__ + "static/media/homeEconomics.bc9eb4ad6d2e9ee4fe43142d5bca7d21.svg";
export { ForwardRef as ReactComponent };